export default __webpack_public_path__ + "static/media/sopha.ca5509ee.png";